<template>

</template>

<script>
import Cookies from "../../../mixins/cookies";

export default {
    name: "tasks-index-quatra",
    mixins: [Cookies],
    mounted() {
        let collapse = $('#collapseExtendedSearch'),
            self     = this;

        collapse.on('shown.bs.collapse', function () {
            self.setCookie('tasksIndexCollapseState', 'open', 1);
        })
        collapse.on('hidden.bs.collapse', function () {
            self.setCookie('tasksIndexCollapseState', 'close', 1);
        })
    }
}
</script>

